enum BookyearStatus {
  Open = 'Open',
  Closing = 'Closing',
  Closed = 'Closed',
}
export default BookyearStatus;
